export interface MobileApp {
  nextButtonTap: () => void;
  backButtonTap: () => void;
  signNow: () => void;
}

export function MobileAppFunctions() {
  const defaultFunctions: MobileApp = {
    nextButtonTap: () => {},
    backButtonTap: () => {},
    signNow: () => {},
  };
  window.mobileApp = window.mobileApp || defaultFunctions;
  return null;
}
